import { Component } from '@angular/core';
import { SkeletonBlock } from '../../../../shared/components/skeleton/skeleton-block';

/** One address section in the desktop/tablet Ship From / Ship To skeleton. */
export interface ShipFromShipToSkeletonSection {
  titleWidth: number;
  primaryCheckLabelWidth: number;
  trailingCheckLabelWidths: readonly number[];
  showFooter: boolean;
}

type ShipFromShipToSkeletonFieldRow =
  { kind: 'grid'; rowClass: string; columnCount: number } | { kind: 'line'; width: number };

const SHIP_FROM_SHIP_TO_SKELETON_SECTIONS: readonly ShipFromShipToSkeletonSection[] = [
  {
    titleWidth: 286,
    primaryCheckLabelWidth: 320,
    trailingCheckLabelWidths: [],
    showFooter: false,
  },
  {
    titleWidth: 258,
    primaryCheckLabelWidth: 356,
    trailingCheckLabelWidths: [480],
    showFooter: true,
  },
];

/** Desktop (≥1200) field grids matching `skelShipFrom`. */
const ADDRESS_FIELD_ROWS_DESKTOP: readonly ShipFromShipToSkeletonFieldRow[] = [
  { kind: 'grid', rowClass: 'ship-from-ship-to-skeleton__row--2', columnCount: 2 },
  { kind: 'grid', rowClass: 'ship-from-ship-to-skeleton__row--3-narrow', columnCount: 3 },
  { kind: 'line', width: 210 },
  { kind: 'grid', rowClass: 'ship-from-ship-to-skeleton__row--3', columnCount: 3 },
  { kind: 'grid', rowClass: 'ship-from-ship-to-skeleton__row--phone', columnCount: 3 },
];

/** Tablet (768–1199) field grids — phone row is 4 cells. */
const ADDRESS_FIELD_ROWS_TABLET: readonly ShipFromShipToSkeletonFieldRow[] = [
  { kind: 'grid', rowClass: 'ship-from-ship-to-skeleton__row--2', columnCount: 2 },
  { kind: 'grid', rowClass: 'ship-from-ship-to-skeleton__row--3-narrow', columnCount: 3 },
  { kind: 'line', width: 210 },
  { kind: 'grid', rowClass: 'ship-from-ship-to-skeleton__row--3', columnCount: 3 },
  { kind: 'grid', rowClass: 'ship-from-ship-to-skeleton__row--phone-4', columnCount: 4 },
];

/** Mobile Ship From stacked field groups (prototype: 3 + 3 + phone/ext/email). */
const MOBILE_FIELD_GROUP_COUNTS = [3, 3] as const;

/**
 * Ship From / Ship To content skeleton (OM-715).
 * Desktop/tablet mirror `skelShipFrom`; mobile mirrors the 390pt Ship From-only body.
 */
@Component({
  selector: 'app-ship-from-ship-to-skeleton',
  imports: [SkeletonBlock],
  templateUrl: './ship-from-ship-to-skeleton.html',
  styleUrl: './ship-from-ship-to-skeleton.scss',
})
export class ShipFromShipToSkeleton {
  protected readonly sections = SHIP_FROM_SHIP_TO_SKELETON_SECTIONS;
  protected readonly fieldRowsDesktop = ADDRESS_FIELD_ROWS_DESKTOP;
  protected readonly fieldRowsTablet = ADDRESS_FIELD_ROWS_TABLET;
  protected readonly mobileFieldGroups = MOBILE_FIELD_GROUP_COUNTS;

  /**
   * Returns a stable track list for repeated column placeholders in a grid row.
   */
  protected columnPlaceholders(count: number): readonly number[] {
    return Array.from({ length: count }, (_, index) => index);
  }
}
